export default __webpack_public_path__ + "static/media/content-deco-2.89b46f78.webp";